// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__u8m1x","tab":"NavBar_tab__low03","tab_text":"NavBar_tab_text__+nSHp","active_tab":"NavBar_active_tab__mPg83"};